import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.updateStockCategoryLocationModal.title, 'Update stock Category location'),
};
